import { getColor } from "../../utils/colorfunctions";

/**
 * ColorDot
 *
 * Renders the DYC color dot for a COA/product color value.
 *   - "synthetic"          → DYC-App-NotAllowed.svg (red not-allowed icon)
 *   - "no color" / falsy  → DYC-App-PendingTerpenes.svg (pending icon)
 *   - any other color      → colored <div> via getColor()
 *
 * Props:
 *   color     — string  The color field value from the DB
 *   className — string  Extra CSS class(es) applied to the element (default: "color-dot")
 *   style     — object  Extra inline styles
 */
function ColorDot({ color, className = "color-dot", style }) {
    if (color === "synthetic") {
        return (
            <img
                src="/colordots/DYC-App-NotAllowed.svg"
                alt="Synthetic"
                className={className}
                style={style}
            />
        );
    }
    if (color === "no color" || !color) {
        return (
            <img
                src="/colordots/DYC-App-PendingTerpenes.svg"
                alt="Pending Terpenes"
                className={className}
                style={style}
            />
        );
    }
    return (
        <div
            className={className}
            style={{ backgroundColor: getColor(color), ...style }}
        />
    );
}

export default ColorDot;
